import type { ReactNode } from "react";

import { SidebarInset, SidebarProvider } from "../primitives/sidebar";
import { ColocaAppShellBreadcrumbProvider } from "./ColocaAppShellBreadcrumbProvider";
import { ColocaAppShellHeader } from "./ColocaAppShellHeader";

type ColocaAppShellProps = {
  sidebar: ReactNode;
  headerActions?: ReactNode;
  children?: ReactNode;
};

export function ColocaAppShell({ sidebar, headerActions, children }: ColocaAppShellProps) {
  return (
    <ColocaAppShellBreadcrumbProvider>
      <SidebarProvider className="h-svh overflow-hidden">
        {sidebar}
        <SidebarInset className="min-h-0 overflow-hidden">
          <ColocaAppShellHeader actions={headerActions} />
          <div className="flex flex-1 min-h-0 flex-col gap-4 overflow-y-auto p-4 pb-[calc(1rem+env(safe-area-inset-bottom))]">
            {children}
          </div>
        </SidebarInset>
      </SidebarProvider>
    </ColocaAppShellBreadcrumbProvider>
  );
}
